/**
 * GA4 Custom Event Tracking for oly Payroll
 * Tracks key funnel actions for conversion analysis.
 */

function track(eventName, params = {}) {
  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
}

export const analytics = {
  // Funnel: Upload
  csvUploaded: (fileName) =>
    track("csv_uploaded", { file_name: fileName }),

  // Funnel: Processing
  processingStarted: (stateCode, payFrequency) =>
    track("processing_started", { state_code: stateCode, pay_frequency: payFrequency }),

  processingCompleted: (shiftCount, employeeCount) =>
    track("processing_completed", { shift_count: shiftCount, employee_count: employeeCount }),

  // Funnel: Download
  reportDownloaded: (fileName) =>
    track("report_downloaded", { file_name: fileName }),

  // Funnel: Auth
  signupCompleted: (method = "email") =>
    track("signup_completed", { method }),

  loginCompleted: () =>
    track("login_completed"),

  // Funnel: Paywall
  paywallShown: (reason) =>
    track("paywall_shown", { reason }),

  checkoutStarted: (packageId) =>
    track("checkout_started", { package_id: packageId }),

  // Engagement
  sampleDataUsed: () =>
    track("sample_data_used"),

  tutorialStarted: () =>
    track("tutorial_started"),

  tabSwitched: (tabName) =>
    track("tab_switched", { tab_name: tabName }),
};
